import { Box, Grid, Typography } from "@mui/material";
import JWTValidatePinView from "./jwt-validate-pin-view";
import { m } from "framer-motion";
import { Helmet } from "react-helmet-async";

export default function ValidatePinPage() {
  return (
    <>
      <Helmet>
        <title>Verify OTP | SiteSnap</title>
      </Helmet>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "#f5f5f5",
        }}
      >
        <Grid
          container
          sx={{ width: "100%", minHeight: "100vh", overflow: "hidden" }}
        >
          {/* Left Section */}
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              bgcolor: "#de4d1b",
              color: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              p: 4,
              minHeight: { xs: 300, md: "100vh" },
            }}
            component={m.div}
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            {/* Logo */}
            <Box
                       sx={{
                         width: 320,
                         height: 120,
                         bgcolor: '#fff',
                         borderRadius: 3,
                         display: 'flex',
                         justifyContent: 'center',
                         alignItems: 'center',
                         mb: 4,
                         boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                         overflow: 'hidden',
                       }}
                     >
                       <Box
                         component="img"
                         src={`${process.env.PUBLIC_URL}/assets/logo.png`}
                         alt="SiteSnap Logo"
                         sx={{
                           width: 240,
                           height: 100,
                           objectFit: 'contain',
                         }}
                       />
                     </Box>

            <Typography
              variant="h3"
              fontWeight="bold"
              textAlign="center"
              sx={{
                mb: 1,
                fontSize: { xs: "1.75rem", md: "2.5rem" },
              }}
            >
              Verify OTP
            </Typography>
            <Typography
              variant="body1"
              textAlign="center"
              sx={{
                opacity: 0.9,
                maxWidth: 380,
                lineHeight: 1.6,
              }}
            >
              Enter the code sent to your email to verify your account.
            </Typography>
          </Grid>

          {/* Right Section */}
          <Grid
            item
            xs={12}
            md={7}
            sx={{
              bgcolor: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 4,
              minHeight: { xs: "auto", md: "100vh" },
            }}
            component={m.div}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Box sx={{ width: "100%", maxWidth: 400 }}>
              <JWTValidatePinView />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
 